module.exports = __webpack_public_path__ + "img/tracker_logo.4d9915e6.svg";